
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Title extends Vue {
  @Prop() title!: string;
  @Prop() subtitle!: string;
  @Prop() color?: string;
  @Prop() subColor?: string;
}
